export default "/048cb1f2b29308e18768c65cfd51e426596a830c/decc719ac0c1523cc2040d71b927dcbc.svg";